import { createFileRoute } from '@tanstack/react-router';
import { FileText } from 'lucide-react';

import { ComplianceSectionTabs } from '@/features/compliance/components/compliance-section-tabs';
import { ContractsLibrary } from '@/features/compliance/components/contracts-library';

export const Route = createFileRoute('/_app/compliance/contratos')({
  component: ComplianceContratosPage,
});

function ComplianceContratosPage() {
  return (
    <div className="flex flex-col gap-6">
      <header className="flex items-start gap-3">
        <span
          className="flex h-9 w-9 items-center justify-center rounded-md"
          style={{ background: 'var(--color-bg-overlay)' }}
          aria-hidden
        >
          <FileText className="h-4 w-4" style={{ color: 'var(--color-fg-muted)' }} />
        </span>
        <div>
          <h1 className="text-2xl font-semibold">Contratos Clientes</h1>
          <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
            Biblioteca de contratos de servicios contables firmados con clientes. Filtros, KPIs y export CSV.
          </p>
        </div>
      </header>

      <ComplianceSectionTabs />

      <ContractsLibrary />
    </div>
  );
}
